"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchGamesByFilters = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var game_api_1 = require("@l2p/game-api");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var games_1 = require("../games");
var geo_1 = require("../geo");
var providers_1 = require("../providers");
var useCache_1 = require("../useCache");
var SELECTED_SEARCH_BY_TITLE = 'selected_search_by_title';
var useSearchGamesByFilters = function (_a) {
    var _b, _c;
    var showCount = _a.showCount, category = _a.category, providerId = _a.providerId, successAction = _a.successAction, withoutCache = _a.withoutCache, _d = _a.allowSearch, allowSearch = _d === void 0 ? true : _d;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var _e = (0, useCache_1.useCache)(), getDataFromCache = _e.getDataFromCache, setDataToCache = _e.setDataToCache;
    var _f = (0, react_1.useState)({
        page: 0,
        limit: showCount,
    }), pageLimit = _f[0], setPageLimit = _f[1];
    var _g = (0, react_1.useState)(withoutCache ? '' : getDataFromCache(SELECTED_SEARCH_BY_TITLE) || ''), searchValue = _g[0], setSearchValue = _g[1];
    var prevSearch = (0, react_1.useRef)(searchValue);
    var searchTimer = (0, react_1.useRef)(null);
    var isReady = (0, react_1.useMemo)(function () { return Object.keys(breakpoints).length > 0; }, [breakpoints]);
    var _h = (0, games_1.useSearchGames)({
        successAction: successAction,
        canRender: isReady,
    }), searchGames = _h.searchGames, data = _h.data, isSubmitting = _h.isSubmitting, error = _h.error;
    var geoData = (0, geo_1.useGeo)().data;
    var gamesData = (0, games_1.useGamesByCategories)().data;
    var providersData = (0, providers_1.useProviders)().data;
    var categoryIncludeGEO = (0, react_1.useMemo)(function () {
        var _a;
        return (0, apps_shared_1.getCategoryKeyWithGeo)({
            category: category,
            countryCode: (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode,
            gamesByCategories: gamesData,
        });
    }, [category, (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode, gamesData]);
    var categoryId = (0, react_1.useMemo)(function () {
        var _a;
        return categoryIncludeGEO
            ? ((_a = gamesData === null || gamesData === void 0 ? void 0 : gamesData[categoryIncludeGEO]) === null || _a === void 0 ? void 0 : _a.id) || undefined
            : undefined;
    }, [categoryIncludeGEO, gamesData]);
    var categories = gamesData
        ? Object.entries(gamesData).map(function (_a) {
            var _ = _a[0], value = _a[1];
            return ({
                id: value.slug,
                title: value.title,
            });
        }, [])
        : [];
    var payload = (0, react_1.useMemo)(function () {
        var _a, _b;
        var filter = {
            devices: [
                breakpoints.mobile || breakpoints.tablet
                    ? game_api_1.GameDeviceTypeEnum.Mobile
                    : game_api_1.GameDeviceTypeEnum.Desktop,
                game_api_1.GameDeviceTypeEnum.Universal,
            ],
            categoryId: categoryId,
            // categories: categoryId ? [categoryId] : undefined,
            providers: providerId ? [providerId] : undefined,
            allowedCountries: ((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode)
                ? [(_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode]
                : undefined,
            currencies: currentCurrency ? [currentCurrency] : undefined,
            title: searchValue ? searchValue : undefined,
        };
        return {
            page: pageLimit.page,
            limit: pageLimit.limit,
            filter: filter,
        };
    }, [
        breakpoints,
        geoData,
        currentCurrency,
        categoryId,
        providerId,
        pageLimit.page,
        pageLimit.limit,
    ]);
    (0, react_1.useEffect)(function () {
        setPageLimit({ page: 0, limit: showCount });
    }, [categoryId]);
    var loadMoreHandler = (0, react_1.useCallback)(function () {
        var limit = pageLimit.limit + showCount;
        setPageLimit({ limit: limit, page: 0 });
    }, [searchGames, showCount, payload]);
    var setSearchValueHandler = (0, react_1.useCallback)(function (value) {
        setSearchValue(value);
        if (!withoutCache) {
            setDataToCache(SELECTED_SEARCH_BY_TITLE, value);
        }
    }, [setSearchValue, setDataToCache, withoutCache]);
    var onSearchChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        setSearchValueHandler(target.value);
    }, []);
    var onSearchClear = (0, react_1.useCallback)(function () {
        setSearchValueHandler('');
    }, []);
    var onFiltersClear = (0, react_1.useCallback)(function () {
        setSearchValueHandler('');
        setPageLimit({ page: 0, limit: showCount });
    }, []);
    var onPageBtnClick = (0, react_1.useCallback)(function (page) {
        setPageLimit(__assign(__assign({}, pageLimit), { page: page + 1 }));
    }, [pageLimit.page]);
    var gamesToShow = (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.edges;
    (0, react_1.useEffect)(function () {
        if (Object.keys(breakpoints).length === 0 ||
            (searchValue !== '' && searchValue.length < 1) ||
            prevSearch.current === searchValue)
            return;
        searchTimer.current = setTimeout(function () {
            if (allowSearch)
                searchGames(__assign(__assign({}, payload), { filter: __assign(__assign({}, payload.filter), { title: searchValue }) }));
        }, 200);
        prevSearch.current = searchValue;
        return function () {
            if (searchTimer.current)
                clearTimeout(searchTimer.current);
        };
    }, [breakpoints, searchGames, searchValue, allowSearch]);
    (0, react_1.useEffect)(function () {
        if (allowSearch)
            searchGames(__assign({}, payload));
    }, [payload, allowSearch]);
    return (0, react_1.useMemo)(function () { return ({
        data: data,
        gamesToShow: gamesToShow,
        searchValue: searchValue,
        currentPage: pageLimit.page,
        categories: categories,
        providers: providersData || [],
        loadMore: loadMoreHandler,
        onSearchChange: onSearchChange,
        onSearchClear: onSearchClear,
        onFiltersClear: onFiltersClear,
        onLoadBtnClick: loadMoreHandler,
        onPageBtnClick: onPageBtnClick,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [isSubmitting, data, loadMoreHandler, error, searchValue, gamesToShow]);
};
exports.useSearchGamesByFilters = useSearchGamesByFilters;
